"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flags = exports.Flag = exports.DefaultFlag = exports.BaseFlag = void 0;
var BaseFlag = /** @class */ (function () {
    function BaseFlag(value, enabled, isDefault) {
        this.value = value;
        this.enabled = enabled;
        this.isDefault = isDefault;
    }
    return BaseFlag;
}());
exports.BaseFlag = BaseFlag;
var DefaultFlag = /** @class */ (function (_super) {
    __extends(DefaultFlag, _super);
    function DefaultFlag(value, enabled) {
        return _super.call(this, value, enabled, true) || this;
    }
    return DefaultFlag;
}(BaseFlag));
exports.DefaultFlag = DefaultFlag;
var Flag = /** @class */ (function (_super) {
    __extends(Flag, _super);
    function Flag(params) {
        var _this = _super.call(this, params.value, params.enabled, !!params.isDefault) || this;
        _this.featureId = params.featureId;
        _this.featureName = params.featureName;
        return _this;
    }
    Flag.fromFeatureStateModel = function (fsm, identityId) {
        return new Flag({
            value: fsm.getValue(identityId),
            enabled: fsm.enabled,
            featureId: fsm.feature.id,
            featureName: fsm.feature.name
        });
    };
    Flag.fromAPIFlag = function (flagData) {
        return new Flag({
            enabled: flagData['enabled'],
            value: flagData['feature_state_value'] || flagData['value'],
            featureId: flagData['feature']['id'],
            featureName: flagData['feature']['name']
        });
    };
    return Flag;
}(BaseFlag));
exports.Flag = Flag;
var Flags = /** @class */ (function () {
    function Flags(data) {
        this.flags = {};
        this.flags = data.flags;
        this.defaultFlagHandler = data.defaultFlagHandler;
        this.analyticsProcessor = data.analyticsProcessor;
    }
    Flags.fromFeatureStateModels = function (data) {
        var e_1, _a;
        var flags = {};
        try {
            for (var _b = __values(data.featureStates), _c = _b.next(); !_c.done; _c = _b.next()) {
                var fs = _c.value;
                flags[fs.feature.name] = Flag.fromFeatureStateModel(fs, data.identityID);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return new Flags({
            flags: flags,
            defaultFlagHandler: data.defaultFlagHandler,
            analyticsProcessor: data.analyticsProcessor
        });
    };
    Flags.fromAPIFlags = function (data) {
        var e_2, _a;
        var flags = {};
        try {
            for (var _b = __values(data.apiFlags), _c = _b.next(); !_c.done; _c = _b.next()) {
                var flagData = _c.value;
                flags[flagData['feature']['name']] = Flag.fromAPIFlag(flagData);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return new Flags({
            flags: flags,
            defaultFlagHandler: data.defaultFlagHandler,
            analyticsProcessor: data.analyticsProcessor
        });
    };
    Flags.prototype.allFlags = function () {
        return Object.values(this.flags);
    };
    Flags.prototype.getFlag = function (featureName) {
        var flag = this.flags[featureName];
        if (!flag) {
            if (this.defaultFlagHandler) {
                return this.defaultFlagHandler(featureName);
            }
            return { enabled: false, isDefault: true, value: undefined };
        }
        if (this.analyticsProcessor && flag.featureId) {
            this.analyticsProcessor.trackFeature(flag.featureName);
        }
        return flag;
    };
    Flags.prototype.getFeatureValue = function (featureName) {
        return this.getFlag(featureName).value;
    };
    Flags.prototype.isFeatureEnabled = function (featureName) {
        return this.getFlag(featureName).enabled;
    };
    return Flags;
}());
exports.Flags = Flags;
